import { render, staticRenderFns } from "./OrientationCard.vue?vue&type=template&id=6b9f3c2c&scoped=true&"
import script from "./OrientationCard.vue?vue&type=script&lang=js&"
export * from "./OrientationCard.vue?vue&type=script&lang=js&"
import style0 from "./OrientationCard.vue?vue&type=style&index=0&id=6b9f3c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f3c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout})
